// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__6_hhR","checkbox":"Checkbox_checkbox__4ooh3"};
module.exports.__checksum = "f0f3d9929126"
